{"id":"ProductDetail.Info.EnergyValuesTable","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.EnergyValuesTable","options":"options:*"}]}}}